"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montecorice": {
    "b125bd47": [{
      "hkey": "9de5ff85",
      "slug": "montecorice",
      "name": "Montecorice",
      "primary": true,
      "skipSearch": false
    }],
    "san-donato": [{
      "hkey": "9de5ff85",
      "slug": "montecorice",
      "name": "Montecorice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bc0c077c": [{
      "hkey": "7a7e33f7",
      "slug": "san-nicola-dei-lembi",
      "name": "San Nicola dei Lembi",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola-dei-lembo": [{
      "hkey": "7a7e33f7",
      "slug": "san-nicola-dei-lembi",
      "name": "San Nicola dei Lembi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "99d812b9": [{
      "hkey": "9de5ff85",
      "slug": "montecorice",
      "name": "Montecorice",
      "primary": true,
      "skipSearch": false
    }],
    "stuorto": [{
      "hkey": "9de5ff85",
      "slug": "montecorice",
      "name": "Montecorice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "03dbe4c2": [{
      "hkey": "817d7ee0",
      "slug": "agnone-cilento",
      "name": "Agnone Cilento",
      "primary": true,
      "skipSearch": false
    }],
    "agnone": [{
      "hkey": "817d7ee0",
      "slug": "agnone-cilento",
      "name": "Agnone Cilento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "809e42cf": [{
      "hkey": "8b8c1eb9",
      "slug": "rosaine",
      "name": "Rosaine",
      "primary": true,
      "skipSearch": false
    }],
    "rosaine-e-magazzeni": [{
      "hkey": "8b8c1eb9",
      "slug": "rosaine",
      "name": "Rosaine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c4e8e747": [{
      "hkey": "7a7e33f7",
      "slug": "san-nicola-dei-lembi",
      "name": "San Nicola dei Lembi",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola": [{
      "hkey": "7a7e33f7",
      "slug": "san-nicola-dei-lembi",
      "name": "San Nicola dei Lembi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;